import { runClientComponent } from '../../_common/client/client-component-runner';
import { ExploreBrandComponent } from './explore-brand.component';

runClientComponent({ ExploreBrandComponent });
